import React, { FunctionComponent, Fragment, useState, useCallback } from "react";
import { Theme, makeStyles, AccordionDetails, Grid } from "@material-ui/core";
import { MenuItemCategory } from "../../../../models/types/category-types";
import { MenuCategoryDictionary } from "../../../../models/categories";
import { TopBarSubcategoryList } from "./tob-bar-subcategory-list";
import { TopBarSubcategoryListHeader } from "./tob-bar-subcategory-list-header";
import { CustomAccordion } from "./../custom-accordion";

export const TOP_BAR_ACCORDION_INSET = 8;

const useStyles = makeStyles((theme: Theme) => ({
  accordionDetailsRoot: {
    padding: 0,
  },
}));

interface ITopBarCategoryAccordionProps {
  onChangeCategory: () => void;
}

export const TopBarCategoryAccordion: FunctionComponent<ITopBarCategoryAccordionProps> = (props) => {
  const { onChangeCategory } = props;
  const classes = useStyles({});
  const [activeCategory, setActiveCategory] = useState<MenuItemCategory | false>(false);
  const categories = Object.values(MenuItemCategory).map((category) => ({
    name: category,
    ...MenuCategoryDictionary[category],
  }));
  const handleCategoryChange = useCallback(
    (category: MenuItemCategory) => (event: React.ChangeEvent<{}>, newExpanded: boolean) => {
      setActiveCategory(newExpanded ? category : false);
    },
    [setActiveCategory],
  );

  return (
    <Grid container>
      {categories.map((category) => {
        if (!category.hidden) {
          return (
            <Grid item xs={12} key={`top-menu-${category.name}`}>
              <CustomAccordion
                elevation={0}
                expanded={activeCategory === category.name}
                onChange={handleCategoryChange(category.name)}
              >
                <TopBarSubcategoryListHeader
                  key={`top-menu-header-${category.name}`}
                  category={category.name}
                  open={activeCategory === category.name}
                />
                <AccordionDetails
                  key={`top-menu-details-${category.name}`}
                  classes={{ root: classes.accordionDetailsRoot }}
                >
                  <TopBarSubcategoryList category={category.name} onActiveCategoryChanges={onChangeCategory} />
                </AccordionDetails>
              </CustomAccordion>
            </Grid>
          );
        }
        return <Fragment key={`top-menu-${category.name}`} />;
      })}
    </Grid>
  );
};
